import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { combineReducers } from "redux";
import dataReducer from "./Reducer";
import { ProductReducer } from "./Reducer";

/**
 * Root Reducer - Combines all reducers
 */
const rootReducer = combineReducers({
  data: dataReducer,
  ProductData: ProductReducer,
});

/**
 * Redux DevTools Composer
 * Uses Redux DevTools Extension if available, otherwise uses default compose
 */
const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

/**
 * Redux Store Configuration
 * Applies Redux Thunk middleware for async actions
 * Integrates Redux DevTools for debugging
 */
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware))
);

// Log store creation in development
if (process.env.NODE_ENV === "development") {
  console.log("Redux Store Initialized");
}

export default store;
